export default function classNameBuilder(...classes: string[]): string {
  const filteredClasses = classes.filter(Boolean);

  if (!filteredClasses.length) return "";

  return filteredClasses.join(" ");
}

